export const layoutConfig = {
    lg: [
        {
            h: 14,
            static: true,
            w: 24,
            x: 0,
            y: 1,
            i: 'c2',
        },
        {
            h: 1,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
    ],
    md: [
        {
            h: 1,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
        {
            h: 10,
            static: true,
            w: 24,
            x: 0,
            y: 2,
            i: 'c2',
        },
    ],
    xs: [
        {
            h: 18,
            static: true,
            w: 24,
            x: 0,
            y: 2,
            i: 'c2',
        },
        {
            h: 1,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
    ],
};
export const pageConfig: PageConfig = {
    pageProps: {},
    components: [
        {
            name: 'page-header',
            key: 'c1',
            props: {
                header: {
                    title: '',
                },
                rhsComponents: [
                    {
                        name: 'page-switcher',
                        props: {
                            text: 'view-reports',
                            path: '/reports/tableau-to-ppt/view-reports',
                            ga_event_name: 'Tableau to PPT > View Reports',
                        },
                    },
                ],
            },
        },
        {
            name: 'generate-reports',
            key: 'c2',
            props: {},
            apiDetails: {
                endpoint: `/reports/tableau/templates?`,
                endpointParams: {},
            },
        },
    ],
};
